import React, { useState, useEffect, useContext } from "react";
import { Buffer } from "buffer";
import Layout from "../Components/Layout";
import Login from "../Components/Login";
import Menu from "../Components/Menu";
import DataTable from "react-data-table-component";
import { getSales } from "../Components/Helpers/Account";
import Spinner from "../Components/Utils/Spinner";
import ErrorResponse from "../Components/Utils/ErrorResponse";
import { AuthContext } from "../App";

export default function Sales({}) {
  const auth = useContext(AuthContext);

  const [items, setItems] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [networkErr, setNetworkErr] = useState(false);
  const columns = [
    {
      name: "Order",
      selector: (row) => "#" + row.custbody_gm_ext_order_ref_num,
    },
    {
      name: "Total",
      selector: (row) => "$" + row.totalamount,
    },
    {
      name: "Status",
      selector: (row) => row.statusname.split(":")[1],
    },
    {
      name: "Shipping Date",
      selector: (row) => row.scheduledshipdate,
      sortable: true,
    },
    {
      name: "Ordered On",
      selector: (row) => row.trandate,
      sortable: true,
    },
  ];

  useEffect(() => {
    if (auth && auth.isAuthenticated && auth.user) {
      const accessToken = auth.user.signInUserSession.accessToken.jwtToken;
      const accessTokenExp =
        auth.user.signInUserSession.accessToken.payload.exp;
      const accessTokenExpTime = new Date(accessTokenExp * 1000).getTime();
      const idToken = auth.user.signInUserSession.idToken.jwtToken;
      const idTokenDecodedBuffer = Buffer.from(
        idToken.split(".")[1],
        "base64"
      ).toString();
      const idTokenDecodedJSON = JSON.parse(idTokenDecodedBuffer);
      const customerID = idTokenDecodedJSON["custom:ns_customer_id"];

      if (accessTokenExpTime < new Date()) {
        location.reload();
        return false;
      }

      // Fetch LoggedIn Customer Details
      getSales(accessToken, customerID)
        .then((result) => {
          console.log(result);
          setItems(result.sales.items);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
          setNetworkErr(true);
        });
    }
  }, [auth]);

  return (
    <>
      <Layout auth={auth} isLoading={isLoading} networkErr={networkErr}>
        {auth && auth.isAuthenticated && auth.user ? (
          <>
            <Menu ordersMenuActive={true} />
            {!isLoading ? (
              <>
                {items && (
                  <div className="bg-gray-100 p-4 lg:p-10 max-w-4xl w-auto lg:w-full my-10 mx-4 lg:mx-auto rounded-md flex flex-col">
                    <h3 className="text-lg">My Orders</h3>
                    <div className="flex flex-row justify-center mt-3 hidden md:flex">
                      <DataTable columns={columns} data={items} />
                    </div>
                    <div className="flex flex-col justify-center mt-3 md:hidden">
                      {items.map((item) => {
                        return (
                          <div
                            className="item rounded-md shadow-md flex flex-col bg-white p-4 my-3"
                            key={item.id}
                          >
                            <p className="flex text-gray-900 font-semibold">
                              ID:{" "}
                              <span className="font-normal ml-auto text-gray-600">
                                {item.tranid}
                              </span>
                            </p>
                            <p className="flex text-gray-900 font-semibold">
                              Total:{" "}
                              <span className="font-normal ml-auto text-gray-600">
                                ${item.totalamount}
                              </span>
                            </p>
                            <p className="flex text-gray-900 font-semibold">
                              Status:{" "}
                              <span className="font-normal ml-auto text-gray-600">
                                {item.statusname.split(":")[1]}
                              </span>
                            </p>
                            <p className="flex text-gray-900 font-semibold">
                              Shipping Date:{" "}
                              <span className="font-normal ml-auto text-gray-600">
                                {item.scheduledshipdate}
                              </span>
                            </p>
                            <p className="flex text-gray-900 font-semibold">
                              Ordered On:{" "}
                              <span className="font-normal ml-auto text-gray-600">
                                {item.trandate}
                              </span>
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <Spinner />
            )}
            {networkErr && (
              <ErrorResponse
                setNetworkErr={setNetworkErr}
                closeEvent="reload"
              />
            )}
          </>
        ) : (
          <Login auth={auth} />
        )}
      </Layout>
    </>
  );
}
